import { Routes, Route } from "react-router-dom";
import { NewsSinglePost, Header, Footer } from "../components";
import { React, useEffect, useState, lazy, Suspense } from "react";
import createClient from '../Client';
import { Home, StaticPages, Demos } from "../pages";
import RequirePassword from "../components/RequirePassword";
import HeaderNew from "../components/redesign/HeaderNew";
import FooterNew from "../components/redesign/FooterNew";
import PageBackground from "../components/redesign/PageBackground";
import ScrollToTop from "../components/redesign/ScrollToTop";

// Lazy-loaded page components for route-based code splitting
const HomeNew = lazy(() => import("../pages/HomeNew"));
const HowItWorksNew = lazy(() => import("../pages/HowItWorksNew"));
const AboutNew = lazy(() => import("../pages/AboutNew"));
const ContactNew = lazy(() => import("../pages/ContactNew"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("../pages/TermsOfService"));

// Feature flag — set to true to use redesigned components
const USE_NEW_DESIGN = true;


const Router = ({ setLoading }) => {
    const [MenuData, setMenuData] = useState([]);
    const [headerLogo, setHeaderLogo] = useState([]);
    const [footerData, setFooterData] = useState([]);

    useEffect(() => {
        createClient.fetch(`*[_type=="settings"][0] {
        "headerMenu":settings_header_menu.links[]{
          ...,

          (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
        },
        "headerLogo":settings_header_logo.asset->url,

          "footer1":settings_footer_menu_1.links[]{
          ...,
          (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
        },
        "footer2":settings_footer_menu_2{
          ...,
          "footerMenu2":settings_footer_menu_2_items.links[] {
            ...,
            (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
          },
          "footerTitle":settings_footer_menu_2_title_text
        },
        "footer3":settings_footer_menu_3{
          ...,
          "footerMenu3":settings_footer_menu_3_items.links[] {
            ...,
            (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
          },
          "footerTitle":settings_footer_menu_3_title_text
        },
        "footerLogo":settings_footer_logo.asset->url,
        "footerContent": settings_footer_content,
        "copywright": settings_footer_copyright_text,
        "footerTagline": settings_footer_tagline,
        "footerEmail": settings_footer_email,
        "twiter": settings_footer_social_icons.settings_footer_social_icons_x,
        "fb":settings_footer_social_icons.settings_footer_social_icons_fb,
        "insta":settings_footer_social_icons.settings_footer_social_icons_insta,
        ...,
      }`).then((data) => {
            setMenuData(data.headerMenu);
            setHeaderLogo(data.headerLogo);
            setFooterData(data);
        })
            .catch(console.error);
    }, [])

    if (USE_NEW_DESIGN) {
        return (
            <PageBackground>
                <ScrollToTop />
                <HeaderNew items={MenuData} headerlogo={headerLogo} />
                {/* Spacer for fixed header */}
                <div className="pt-[72px]">
                    <main className="flex-grow">
                        <Suspense fallback={null}>
                        <Routes>
                            <Route path='/' element={<HomeNew setLoading={setLoading} />} />
                            <Route path='/how-it-works' element={<HowItWorksNew setLoading={setLoading} />} />
                            <Route path='/about' element={<AboutNew />} />
                            <Route path='/about-us' element={<AboutNew />} />
                            <Route path='/contact' element={<ContactNew />} />
                            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                            <Route path='/terms-of-service' element={<TermsOfService />} />
                            <Route
                                path='/demos'
                                element={
                                    <RequirePassword title="Product demos">
                                        <Demos />
                                    </RequirePassword>
                                }
                            />
                            <Route path='/:slugId' element={<StaticPages setLoading={setLoading} footerData={footerData} items={MenuData} />} />
                            <Route path='/news/:postId' element={<NewsSinglePost setLoading={setLoading} footerData={footerData} items={MenuData} />} />
                        </Routes>
                        </Suspense>
                    </main>
                </div>
                <FooterNew footerData={footerData} headerlogo={headerLogo} />
            </PageBackground>
        );
    }

    return (
        <>
            <Header items={MenuData} headerlogo={headerLogo}></Header>
            <Routes>
            {/* this is static, static page about-us is changed to home */}
                <Route path='/' element={<Home setLoading={setLoading} footerData={footerData} items={MenuData}></Home>}></Route>
                <Route
                    path='/demos'
                    element={
                        <RequirePassword title="Product demos">
                            <Demos />
                        </RequirePassword>
                    }
                ></Route>
                <Route path='/:slugId' element={<StaticPages setLoading={setLoading} footerData={footerData} items={MenuData} ></StaticPages>}></Route>
                {/* <Route path='/' element={<StaticPages></StaticPages>}></Route> */}
                <Route path='/news/:postId' element={<NewsSinglePost setLoading={setLoading} footerData={footerData} items={MenuData}></NewsSinglePost>}></Route>
            </Routes>
            <Footer footerData={footerData} items={MenuData}></Footer>
        </>
    );
}

export default Router;
